@if (tabs().length > 0 && magazine) {
  <div class="w-full overflow-visible">
    <!-- Tab Navigation -->
    <div class="mb-6">
      <!-- Mobile Accordion (shown below md breakpoint) -->
      <div class="block md:hidden">
        <!-- Custom accordion implementation that directly shows tab content -->
        <div class="w-full">
          @for (tab of tabs(); track tab) {
            <div class="border-b border-neutral-200 py-4">
              <!-- Accordion header -->
              <button
                class="flex w-full cursor-pointer items-center justify-between focus:outline-none"
                [attr.aria-expanded]="isAccordionSectionExpanded(tab.id)"
                (click)="toggleAccordionSection(tab.id)"
              >
                <span
                  class="text-lg font-medium"
                  [ngClass]="{
                    'text-orange-500': isAccordionSectionExpanded(tab.id),
                    'text-neutral-800': !isAccordionSectionExpanded(tab.id),
                  }"
                >
                  {{ tab.title | translate }}
                </span>
                <img
                  class="h-4 w-4 transition-transform"
                  [src]="'assets/icons/plus_icon.svg'"
                  [alt]="'components.filter.expandIcon' | translate"
                  [ngClass]="{
                    'text-orange-500': isAccordionSectionExpanded(tab.id),
                    'rotate-45': isAccordionSectionExpanded(tab.id),
                  }"
                />
              </button>
              <!-- Accordion content -->
              <div
                class="overflow-hidden transition-all duration-300"
                [ngClass]="{
                  'max-h-0 opacity-0': !isAccordionSectionExpanded(tab.id),
                  'pt-4 opacity-100': isAccordionSectionExpanded(tab.id),
                }"
              >
                <!-- For non-editions and non-articles tabs -->
                @if (!tab.isEditions && !tab.isArticles && magazine) {
                  <div class="max-w-none text-neutral-700">
                    @switch (tab.id) {
                      <!-- More Info Tab -->
                      @case ('more-info') {
                        <!-- Use the shared template with hideTitle=true for mobile -->
                        <ng-container
                          *ngTemplateOutlet="
                            moreInfoContent;
                            context: { hideTitle: true }
                          "
                        ></ng-container>
                      }
                      <!-- For Whom Tab (Mobile) -->
                      @case ('for-whom') {
                        <!-- Responsive For Whom content with mobile-specific styling -->
                        <ng-container
                          *ngTemplateOutlet="
                            forWhomContent;
                            context: { isMobile: true }
                          "
                        ></ng-container>
                      }
                      <!-- Prices Tab (Mobile) -->
                      @case ('prices') {
                        <!-- Use the shared template with hideTitle=true for mobile -->
                        <ng-container
                          *ngTemplateOutlet="
                            pricesContent;
                            context: { hideTitle: true }
                          "
                        ></ng-container>
                      }
                      <!-- Author Guidelines Tab -->
                      @case ('author-guidelines') {
                        <!-- Use the shared template with hideTitle=true for mobile -->
                        <ng-container
                          *ngTemplateOutlet="
                            authorGuidelinesContent;
                            context: { hideTitle: true }
                          "
                        ></ng-container>
                      }
                    }
                  </div>
                }
                <!-- For editions tab -->
                @if (tab.isEditions) {
                  <div class="w-full">
                    <!-- Mobile Year Filter Button -->
                    <ng-container
                      *ngTemplateOutlet="mobileYearFilter"
                    ></ng-container>
                    <!-- Use the shared editionsContent template -->
                    <ng-container
                      *ngTemplateOutlet="editionsContent"
                    ></ng-container>
                  </div>
                }
                <!-- For articles tab only -->
                @if (tab.isArticles && magazine) {
                  <div class="w-full">
                    <dhp-se-magazine-articles
                      [magazine]="magazine"
                    ></dhp-se-magazine-articles>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
      <!-- Desktop Tabs (hidden below md breakpoint) -->
      <div class="relative hidden border-b-2 border-neutral-200 md:block">
        <div class="flex items-start gap-5 pt-4">
          @for (tab of tabs(); track tab; let i = $index) {
            <button
              class="relative pb-4 text-xl font-medium transition duration-300 focus:outline-none"
              [ngClass]="
                isActive(tab.id)
                  ? 'text-orange-500'
                  : 'text-neutral-600 hover:text-orange-400'
              "
              [attr.aria-selected]="isActive(tab.id)"
              [attr.tabindex]="isActive(tab.id) ? 0 : -1"
              (click)="selectTab(tab.id)"
            >
              {{ tab.title | translate }}
              <!-- Orange indicator positioned slightly above the gray border -->
              @if (isActive(tab.id)) {
                <div
                  class="absolute right-0 bottom-0 left-0 h-0.5 bg-orange-500"
                ></div>
              }
            </button>
          }
        </div>
      </div>
    </div>
    <!-- Tab Content - Now hidden on mobile -->
    <div class="mt-6 hidden md:block">
      <!-- Tab content container for all tabs (both editions and non-editions) -->
      @for (tab of tabs(); track tab) {
        <!-- Tab content wrapper -->
        <div
          [ngClass]="{
            'tab-content transition-all duration-300': true,
            'active block': isActive(tab.id),
            hidden: !isActive(tab.id),
          }"
        >
          <!-- Content for editions tab -->
          @if (tab.isEditions) {
            <div class="w-full">
              <!-- Main Title -->
              <h2 class="mb-8 text-3xl font-medium text-neutral-800">
                {{ 'components.journalItem.overviewAllEditions' | translate }}
              </h2>
              <!-- Desktop Year Filter Buttons -->
              <ng-container
                *ngTemplateOutlet="yearFilterButtons"
              ></ng-container>
              <!-- Use the shared editionsContent template -->
              <ng-container *ngTemplateOutlet="editionsContent"></ng-container>
            </div>
          }
          <!-- Content for articles tab -->
          @if (tab.isArticles) {
            <div class="w-full">
              <dhp-se-magazine-articles
                [magazine]="magazine"
              ></dhp-se-magazine-articles>
            </div>
          }
          <!-- Content for non-editions tabs -->
          @if (!tab.isEditions && !tab.isArticles) {
            <div class="h-auto w-full">
              @switch (tab.id) {
                <!-- More Info Tab -->
                @case ('more-info') {
                  <!-- Use the shared template with hideTitle=false for desktop -->
                  <ng-container
                    *ngTemplateOutlet="
                      moreInfoContent;
                      context: { hideTitle: false }
                    "
                  ></ng-container>
                }
                <!-- For Whom Tab (Desktop) -->
                @case ('for-whom') {
                  <!-- Responsive For Whom content with desktop-specific styling -->
                  <ng-container
                    *ngTemplateOutlet="
                      forWhomContent;
                      context: { isMobile: false }
                    "
                  ></ng-container>
                }
                <!-- Prices Tab (Desktop) -->
                @case ('prices') {
                  <!-- Use the shared template with hideTitle=false for desktop -->
                  <ng-container
                    *ngTemplateOutlet="
                      pricesContent;
                      context: { hideTitle: false }
                    "
                  ></ng-container>
                }
                <!-- Author Guidelines Tab (Desktop) -->
                @case ('author-guidelines') {
                  <!-- Use the shared template with hideTitle=false for desktop -->
                  <ng-container
                    *ngTemplateOutlet="
                      authorGuidelinesContent;
                      context: { hideTitle: false }
                    "
                  ></ng-container>
                }
                <!-- Articles Tab (Desktop) - Only for Selection and Essence magazines -->
                @case ('articles') {
                  <!-- Regular component -->
                  <dhp-se-magazine-articles
                    [magazine]="magazine"
                  ></dhp-se-magazine-articles>
                }
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
}

<!-- Year Filter Dialog Component -->
<dhp-year-filter-dialog
  [(isOpen)]="isYearFilterOpen"
  [(yearSelected)]="yearSelected"
  [years]="years()"
></dhp-year-filter-dialog>

<!-- Reusable template for year filter buttons (desktop) -->
<ng-template #yearFilterButtons>
  <div class="mt-4 flex items-start justify-between">
    <div class="flex flex-wrap items-center justify-start gap-x-2 gap-y-3">
      <!-- Year filter buttons -->
      @for (year of years(); track year) {
        @if (year.count !== 0) {
          <button
            class="btn btn-outline"
            [ngClass]="{
              'btn-active': yearSelected?.value === year.value,
            }"
            [disabled]="editions().length === 0"
            [attr.aria-pressed]="yearSelected?.value === year.value"
            (click)="onYearChange(year)"
            type="button"
          >
            <span>{{
              'components.magazineTabs.yearAndCount'
                | translate: { year: year.label }
            }}</span>
          </button>
        }
      }
    </div>
  </div>
  <hr class="mt-4 mb-4 border-neutral-300" />
</ng-template>

<!-- Reusable template for For Whom content -->
<ng-template #forWhomContent let-isMobile="isMobile">
  <div [ngClass]="isMobile ? 'flex-col gap-4' : 'flex-col gap-10'">
    <!-- Title - only shown on desktop view -->
    @if (!isMobile) {
      <h2 class="mb-8 text-3xl font-medium text-neutral-800">
        {{ 'pages.magazinesAndJournals.accordionSections.forWhom' | translate }}
      </h2>
    }

    <!-- Content section with responsive layout -->
    <div [ngClass]="isMobile ? 'flex-col' : 'flex items-start gap-5 pb-7'">
      <!-- Text section -->
      <div [ngClass]="isMobile ? 'mb-6 w-full py-2' : 'w-2/5 pr-4'">
        <div class="text-base leading-normal font-normal text-neutral-800">
          {{
            'pages.magazinesAndJournals.accordionContent.forWhom.relevantSectors'
              | translate
          }}
        </div>
      </div>

      <!-- Tags section with responsive styling -->
      <div
        [ngClass]="
          isMobile
            ? 'flex w-full flex-col space-y-2'
            : 'flex w-3/5 flex-col gap-2'
        "
      >
        @for (tag of magazine.tags; track tag) {
          <div
            [ngClass]="
              isMobile
                ? 'w-fit rounded-full border border-neutral-300 px-5 py-2'
                : 'w-fit rounded-full border border-neutral-200 px-5 py-2'
            "
          >
            <div
              [ngClass]="
                isMobile
                  ? 'text-base leading-normal font-normal text-neutral-800'
                  : 'text-base leading-normal font-medium text-neutral-900'
              "
            >
              {{ tag.tag }}
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>

<!-- Reusable template for Editions content -->
<ng-template #editionsContent>
  <!-- Loading state - only show this loading indicator when no editions are available yet -->
  @if (loading() && filteredEditions().length === 0) {
    <div class="flex items-center justify-center py-8">
      <div class="text-center text-neutral-500">
        {{ 'components.header.loading' | translate }}
      </div>
    </div>
  }

  <!-- Show editions list -->
  @if (filteredEditions().length > 0) {
    <div class="w-full">
      <dhp-magazine-edition-overview
        [magazine]="magazine"
        [editions]="filteredEditions()"
        [selectedYear]="yearSelected?.value ?? null"
      ></dhp-magazine-edition-overview>
    </div>
  }

  <!-- No editions message -->
  @if (!loading() && (!filteredEditions || filteredEditions.length === 0)) {
    <div class="text-center text-neutral-500">
      {{ 'components.journalItem.noEditionsAvailable' | translate }}
    </div>
  }
</ng-template>

<!-- Reusable template for More Info content -->
<ng-template #moreInfoContent let-hideTitle="hideTitle">
  <dhp-more-info [magazine]="magazine" [hideTitle]="hideTitle"></dhp-more-info>
</ng-template>

<!-- Reusable template for Prices content -->
<ng-template #pricesContent let-hideTitle="hideTitle">
  <dhp-prices [data]="magazine" [hideTitle]="hideTitle"></dhp-prices>
</ng-template>

<!-- Reusable template for Author Guidelines content -->
<ng-template #authorGuidelinesContent let-hideTitle="hideTitle">
  <dhp-author-guidelines
    [instructionsUrls]="getAuthorInstructionsUrls()"
    [hideTitle]="hideTitle"
  ></dhp-author-guidelines>
</ng-template>

<!-- Reusable template for mobile year filter button -->
<ng-template #mobileYearFilter>
  <div class="mb-4 md:hidden">
    <button
      class="flex w-full items-center justify-between rounded-full border border-neutral-300 bg-white px-5 py-2.5 text-left"
      [attr.aria-label]="'components.filter.yearFilterButtonLabel' | translate"
      (click)="isYearFilterOpen = true"
    >
      <span class="text-base font-medium text-neutral-800">
        {{ yearSelected?.label }}
      </span>
      <!-- Plus icon instead of arrow -->
      <span
        class="flex h-5 w-5 items-center justify-center text-xl font-bold"
        aria-hidden="true"
        >+</span
      >
    </button>
  </div>
</ng-template>
